import { useEffect, useRef, useState } from "react";
import { AuthedApi } from "./Api";
import { Action, VoidAction } from "../util/func";

export default function useAuthedApi(showError: Action<string>): [AuthedApi | null | undefined, VoidAction] {
  const [authedApi, setAuthedApi] = useState<AuthedApi | null>();
  // 直近の authedApi をミラーする ref。アンマウント時の cleanup は state を経由せず、
  // ここから直接 resetApi() して現行インスタンスを破棄する。
  const currentApiRef = useRef<AuthedApi | null | undefined>(authedApi);
  currentApiRef.current = authedApi;
  // update() の並行呼び出しで古い AuthedApi.Get の結果が後着で最新を上書きしないための世代カウンタ。
  // Get 完了時にこの値が呼び出し時点と変わっていれば、その結果は古い世代とみなし破棄する。
  const generationRef = useRef(0);

  useEffect(() => {
    if (!authedApi) {
      update();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      generationRef.current += 1;
      currentApiRef.current?.resetApi();
    };
  }, []);

  const update = () => {
    const generation = ++generationRef.current;
    authedApi?.resetApi();
    AuthedApi.Get(() => {
      if (generation !== generationRef.current) {
        return;
      }
      setAuthedApi((prev) => {
        prev?.resetApi();
        return null;
      });
    }, showError).then((newAuthedApi) => {
      if (generation !== generationRef.current) {
        newAuthedApi?.resetApi();
        return;
      }
      setAuthedApi((prev) => {
        prev?.resetApi();
        return newAuthedApi;
      });
    });
  }

  return [authedApi, update];
}

